import React from 'react';

const StatsCard = ({ 
  title, 
  totalLabel = "Total", 
  totalValue, 
  anomalousLabel = "Anomalous", 
  anomalousValue, 
  percentageLabel = "Percentage", 
  percentageValue, 
  unit = "" 
}) => {
  return (
    <div className="stats-card">
      <h4 className="stats-card-title">{title}</h4>
      <div className="stats-card-content">
        <div className="stats-item">
          <div className="stats-label">{totalLabel}</div>
          <div className="stats-value">{totalValue.toLocaleString()}</div>
        </div>
        <div className="stats-item">
          <div className="stats-label">{anomalousLabel}</div>
          <div className="stats-value anomalous">{anomalousValue.toLocaleString()}</div>
        </div>
        <div className="stats-item">
          <div className="stats-label">{percentageLabel}</div>
          <div className="stats-value percentage">{percentageValue.toFixed(2)}%</div>
        </div>
      </div>
      {unit && <div className="stats-unit">({unit})</div>}
    </div>
  );
};

export default StatsCard;
